/**
 * @generated SignedSource<<45a51bfc554dbe8c0380bb8d0d27ca01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemTileTooltip_nftItemDraft$data = {
  readonly serviceId: string | null;
  readonly user: {
    readonly ethereumWalletAddress: {
      readonly publicProfileUrl: string | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderWithImage_draft">;
  readonly " $fragmentType": "NftItemTileTooltip_nftItemDraft";
};
export type NftItemTileTooltip_nftItemDraft$key = {
  readonly " $data"?: NftItemTileTooltip_nftItemDraft$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileTooltip_nftItemDraft">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftItemTileTooltip_nftItemDraft",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "ethereumWalletAddress",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicProfileUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderWithImage_draft"
    }
  ],
  "type": "NftItemDraft",
  "abstractKey": null
};

(node as any).hash = "562529ce6206d1f8a6a0ccdfcd023afa";

export default node;
